import mitt from 'mitt'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

/**
 * withApp callback for createInertiaApp. Kept in a module (rather than inline
 * in the inertia-rewritten entry) so its sourcemap survives for Bugsnag — the
 * @inertiajs/vite plugin transforms resources/js/app.js without emitting a map.
 * Bugsnag is browser-only, so it is skipped during SSR.
 */
export function configureApp(app, { ssr }) {
    app.provide('mitt', mitt())

    if (!ssr) {
        Bugsnag.start({
            apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
            plugins: [new BugsnagPluginVue()],
        })

        app.use(Bugsnag.getPlugin('vue'))
    }
}
